import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { Card, FormControl, Grid, Icon, InputLabel, MenuItem, Select } from "@mui/material";
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import queryString from "components/queryString";
import Loading from "components/Loading";
import { getRequestGroup, getReservationFullList } from "api/routes";
import React, { useEffect, useState } from "react";
import DataTable from "examples/Tables/DataTable";
import tableData from "./TableData";
import { getReservedSubTimesN } from "api/routes";
import moment from "jalali-moment";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

export default function ReservationStatus() {
  const [loading, setLoading] = useState(false);
  const [reservationList, setReservationList] = useState([]);
  const [reservedTimes, setReservedTimes] = useState([]);
  const [clickedRequestGroupId, setClickedRequestGroupId] = useState(7);
  const [requestGroupData, setRequestGroupData] = useState([]);
  const [dateRange, setDateRange] = useState(moment().locale("fa").format("YYYYMMDD"));
  const navigate = useNavigate()
  const { rows, columns } = tableData(reservationList, reservedTimes,navigate);
  useEffect(() => {
    const query = {
      requestGroupId: clickedRequestGroupId,
      todayDate: dateRange,
    };
    setLoading(true);
    getReservationFullList(queryString(query), (isOk, data) => {
      if (!isOk) {
        setLoading(false);
        return toast.error(data.message);
      } else {
        return setReservationList(data);
      }
    });
    const query2 = {
      requestGroupId: clickedRequestGroupId,
      todayDate: dateRange,
    };
    getReservedSubTimesN(queryString(query2), (isOk, data) => {
      if (!isOk) {
        setLoading(false);
        return toast.error(data.message);
      } else {
        setLoading(false);
        return setReservedTimes(data);
      }
    });
  }, [clickedRequestGroupId, dateRange]);
  useEffect(() => {
    const query = {
      all: 1,
    };
    getRequestGroup((isOk, data) => {
      if (!isOk) return toast.error(data.message);
      else return setRequestGroupData(data);
    }, queryString(query));
  }, []);

  return (
    <>
      <DashboardLayout>
        <Loading loading={loading} />
        <MDBox pt={2} mb={6}>
          <Grid container spacing={6}>
            <Grid item xs={12}>
              <Card>
                <MDBox
                  mx={2}
                  mt={-3}
                  py={3}
                  px={2}
                  variant="gradient"
                  bgColor="info"
                  borderRadius="lg"
                  coloredShadow="info"
                  style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
                >
                  <MDTypography variant="h6" color="white">
                    وضعیت نوبت ها
                  </MDTypography>
                  <DashboardNavbar />
                </MDBox>
                <div style={{ display: "flex", margin: "1rem 0 0 1rem" }}>
                  <FormControl sx={{ width: "200px", margin: "0 1rem" }}>
                    <InputLabel>گروه</InputLabel>
                    <Select
                      value={clickedRequestGroupId}
                      onChange={(event) => setClickedRequestGroupId(event.target.value)} label="گروه"
                      sx={{ height: "44.3px" }}>
                      {requestGroupData.map((item) => !item.isNoteBook &&
                        <MenuItem key={item.requestGroupId} value={item.requestGroupId}>{item.nameGroup}</MenuItem>,
                      )}
                    </Select>
                  </FormControl>
                </div>
                <MDBox pt={3} px={2} display="flex" justifyContent={"space-between"}>
                  <div style={{ marginLeft: 10, cursor: "pointer" }}>
                    <Icon fontSize="large"
                          onClick={() => setDateRange(moment(dateRange, "jYYYYjMMjDD").locale("fa").subtract(10, "d").format("jYYYYjMMjDD"))}
                          style={{ color: "rgb(62, 205, 219)" }}>navigate_next</Icon>
                  </div>
                  <p style={{fontSize:18}}>{`${String(dateRange).slice(0, 4)}/${String(dateRange).slice(4, 6)}/${String(dateRange).slice(6)}`} - {moment(dateRange, "jYYYYjMMjDD").locale("fa").add(10, "d").format("jYYYY/jMM/jDD")}</p>
                  <Icon fontSize="large"
                        onClick={() => setDateRange(moment(dateRange, "jYYYYjMMjDD").locale("fa").add(10, "d").format("jYYYYjMMjDD"))}
                        style={{ cursor: "pointer", color: "rgb(62, 205, 219)" }}>chevron_left</Icon>
                </MDBox>
                {reservationList.length > 0 && <DataTable
                  table={{ columns, rows }}
                  isSorted={false}
                  entriesPerPage={false}
                  showTotalEntries={false}
                />}
              </Card>
            </Grid>
          </Grid>
        </MDBox>
        <Footer />
      </DashboardLayout>
    </>
  );
}
